import { CartLineItem } from '@/types';

type CartLineItemWithMenuTitle = CartLineItem & {
  menuTitle?: string | null;
};

const SIZE_ID = /(?:the\s+)?size_id\s+([\w-]+)/i;
const SELLABLE_QTY = /(sellable quantity\s+)(\d+(?:\.\d+)?)/i;

export const formatInsufficientSellableQuantityMessage = (
  lineItems: CartLineItem[],
  message?: string,
): string => {
  if (!message) {
    return '';
  }

  const sizeId = message.match(SIZE_ID)?.[1];
  const sellableQuantityMatch = message.match(SELLABLE_QTY)?.[2];
  const sellableQuantity = Number(sellableQuantityMatch ?? 0);
  const lineItem = lineItems?.find(item => item.id?.toString() === sizeId);
  const displayName =
    (lineItem as CartLineItemWithMenuTitle)?.menuTitle || lineItem?.name;
  const requestedQuantity = lineItem?.quantity ?? 0;

  if (!displayName) {
    return message;
  }
  return (
    `The quantity requested ${requestedQuantity} for ${displayName} ` +
    `exceeds the sellable quantity ${sellableQuantity}. Please update your cart.`
  );
};
